export const clickElementByShortcutId = (shortcutId: string) => {
  const element = document.querySelector(`[data-shortcut-id="${shortcutId}"]`);

  if (element) {
    (element as HTMLElement).click();
  } else {
    console.warn(`Element with data-shortcut-id "${shortcutId}" not found`);
  }
};
